/**
 * Retired path. The SCIM endpoint and the sources that push to it are the
 * Sources tab of People → Connections; bookmarks keep resolving.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/provisioning")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/tenants/$slug/directory", params: { slug: params.slug } });
  },
});
